import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class CreateFormService {
  private apiUrl = '/spring/createForm';

  constructor(private http: HttpService) { }

  //CreateFormのjsがPostするための帳票取得APIのURLを返却
  getReportUrl(){
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/clientprint`;
    return url;
  }

    //CreateForm帳票（CSVデータ作成のみ）
    generateCreateformCsv(
      reportCd: string,
      reporttrnId: number
    ): Promise<any> {
      const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + "/createcsv/" + reportCd}`;
      let jsonInput = {};
      jsonInput = {
        reporttrnId: reporttrnId
      };
      return this.http.post(url, jsonInput);
    }
  
    //CreateForm帳票（File取得）
    generateCreateformFile(
      reportCd: string,
      reporttrnId: number
    ): Promise<any> {
      const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + "/createfile/" + reportCd}`;
      let jsonInput = {};
      jsonInput = {
        reporttrnId: reporttrnId
      };
      return this.http.post(url, jsonInput);
    }

    //CreateForm帳票（TXTデータ作成）
    generateCreateformTxt(
      reportCd: string,
      reporttrnId: number
    ): Promise<any> {
      const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + "/createtxt/" + reportCd}`;
      let jsonInput = {};
      jsonInput = {
        reporttrnId: reporttrnId
      };
      return this.http.post(url, jsonInput);
    }

}


// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/create-form/create-form.service.ts